import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import { useApolloClient, gql } from "@apollo/client";
import NotShittyUploadcareWidget from "./NotShittyUploadcareWidget";
import SvgEdit24Px from "../icons/SvgEdit";
import TextInput from "./TextInput";
import ContentEditable from "react-contenteditable";
import LoadingScreen from "./LoadingScreen";
import ErrorScreen from "./ErrorScreen";
import NotFoundScreen from "./NotFoundScreen";
import UpdateVideo from "./UpdateVideo";
import { processUpload } from "../cache/transformers";
import { CompactPicker } from 'react-color';
const webFonts = [
    'Archivo', 'Arial', 'Assistant', 'BioRhyme', 'Bodoni Moda',
    'Crimson Text', 'Dosis', 'EB Garamond', 'Helvetica', 'Hind',
    'Inconsolata', 'Indie Flower', 'Jost', 'Karla', 'Lato',
    'Libre Baskerville', 'Martel Sans', 'Merriweather', 'Montserrat',
    'News Cycle', 'Nunito', 'Open Sans', 'Oswald', 'Palanquin',
    'Playfair Display', 'Poppins', 'Questrial', 'Raleway', 'Roboto',
    'Sarpanch', 'Sorts Mill Goudy', 'Source Sans Pro', 'Times New Roman'
];
import { UpdateBusinessFieldInputFragmentDoc, UpdateThemeFieldInputFragmentDoc, useBrandScreenInnerQuery, useUpdateLogoMutation, useUpdateCoverPhotoMutation, } from "../types";
import { stripHtml, preventEnter } from "../helpers/tools";
import { Card } from "@tremor/react";
gql `
  fragment UpdateBusinessFieldInput on Business {
    mission
    oneLiner
  }

  fragment UpdateThemeFieldInput on Theme {
    highlightColor
    darkColor
    defaultColor
    font
  }

  query BrandScreenInner($id: ID!) {
    business(id: $id) {
      id
      alias
      status
      name
      address {
        neighborhood
        city
        stateAbbreviated
      }
      coverPhoto {
        id
        cdnPath
      }
      logo {
        id
        cdnPath
      }
      theme {
        id
        ...UpdateThemeFieldInput
      }
      ...UpdateBusinessFieldInput
      ...UpdateBusiness
      ...ExperienceScreenPreferences
    }
  }
`;
const BrandScreenInner = ({ businessId, fromPreOnboarding = false }) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p;
    const client = useApolloClient();
    const { loading, error, data } = useBrandScreenInnerQuery({
        variables: { id: businessId },
    });
    const [updateCoverPhoto] = useUpdateCoverPhotoMutation();
    const [updateLogo] = useUpdateLogoMutation();
    const oneLinerRef = useRef(null);
    const editOneLinerRef = useRef(null);
    const editDescriptionRef = useRef(null);
    const handleUpload = async (currentFile) => {
        // mixpanel.track("Manage Upsells", {
        //   action: "Updated Cover Photo",
        // })
        const params = processUpload(currentFile);
        if (!params) {
            return;
        }
        await updateCoverPhoto({
            variables: {
                businessId: businessId,
                imageInput: params,
            },
        });
    };
    const handleUploadLogo = async (currentFile) => {
        // mixpanel.track("Manage Upsells", {
        //   action: "Updated Logo",
        // })
        const params = processUpload(currentFile);
        if (!params) {
            return;
        }
        await updateLogo({
            variables: {
                businessId: businessId,
                imageInput: params,
            },
        });
    };
    const [widget, setWidget] = useState(null);
    const [logoWidget, setLogoWidget] = useState(null);
    const [openAccentColorPicker, setOpenAccentColorPicker] = useState(false);
    const [openButtonColorPicker, setOpenButtonColorPicker] = useState(false);
    const [openBackgroundColorPicker, setOpenBackgroundColorPicker] = useState(false);
    const [theme, setTheme] = useState(null);
    useEffect(() => {
        var _a;
        if ((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.oneLiner) {
            oneLinerRef.current = data.business.oneLiner;
        }
    }, [(_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.oneLiner]);
    useEffect(() => {
        var _a;
        if ((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.theme) {
            setTheme(data.business.theme);
        }
    }, [(_b = data === null || data === void 0 ? void 0 : data.business) === null || _b === void 0 ? void 0 : _b.theme]);
    oneLinerRef.current = oneLinerRef.current || ((_c = data === null || data === void 0 ? void 0 : data.business) === null || _c === void 0 ? void 0 : _c.oneLiner);
    useEffect(() => {
        var _a, _b, _c, _d, _e, _f;
        console.log(!!((_b = (_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.coverPhoto) === null || _b === void 0 ? void 0 : _b.cdnPath));
        const w = (data ? _jsx(NotShittyUploadcareWidget, { image: (_c = data === null || data === void 0 ? void 0 : data.business) === null || _c === void 0 ? void 0 : _c.coverPhoto, onChangeCallback: handleUpload, crop: "10:3" }) : _jsx("div", { children: "Loading..." }));
        setWidget(w);
        console.log(!!((_e = (_d = data === null || data === void 0 ? void 0 : data.business) === null || _d === void 0 ? void 0 : _d.logo) === null || _e === void 0 ? void 0 : _e.cdnPath));
        const lw = (data ? _jsx(NotShittyUploadcareWidget, { image: (_f = data === null || data === void 0 ? void 0 : data.business) === null || _f === void 0 ? void 0 : _f.logo, onChangeCallback: handleUploadLogo, crop: "1:1" }) : _jsx("div", { children: "Loading..." }));
        setLogoWidget(lw);
    }, [(_e = (_d = data === null || data === void 0 ? void 0 : data.business) === null || _d === void 0 ? void 0 : _d.coverPhoto) === null || _e === void 0 ? void 0 : _e.cdnPath, (_g = (_f = data === null || data === void 0 ? void 0 : data.business) === null || _f === void 0 ? void 0 : _f.logo) === null || _g === void 0 ? void 0 : _g.cdnPath]);
    if (loading) {
        return _jsx(LoadingScreen, {});
    }
    if (error) {
        return _jsx(ErrorScreen, { message: error.message });
    }
    if (!(data === null || data === void 0 ? void 0 : data.business)) {
        return _jsx(NotFoundScreen, {});
    }
    const updateThemeField = (field) => {
        return (value) => {
            let fieldValue;
            switch (field) {
                case 'highlightColor':
                case 'darkColor':
                case 'defaultColor':
                    fieldValue = value === null || value === void 0 ? void 0 : value.hex;
                    break;
                case 'font':
                    fieldValue = value;
                    break;
            }
            if (theme === null || theme === void 0 ? void 0 : theme.id) {
                client.writeFragment({
                    id: `Theme:${theme.id}`,
                    fragment: UpdateThemeFieldInputFragmentDoc,
                    data: Object.assign(Object.assign({}, theme), { [field]: fieldValue }),
                });
                // Read the updated theme data from the cache
                // No idea why I need to do this but it didn't rerender without it
                const updatedTheme = client.readFragment({
                    id: `Theme:${theme.id}`,
                    fragment: UpdateThemeFieldInputFragmentDoc,
                });
                setTheme(Object.assign(Object.assign({}, updatedTheme), { id: theme.id }));
            }
        };
    };
    const updateBusinessField = (field) => {
        return (ev) => {
            // This is all for firefox, which needs random brs left in there to work, but we also want to remove the single br version which breaks the interface
            // I don't think the doBroadcast part works, I was trying make a slightly nicer firefox experience
            const value = ['oneLiner'].includes(field) ? stripHtml(ev.target.value) : ev.target.value;
            const doBroadcast = !['oneLiner'].includes(field) || !value || value == " ";
            client.writeFragment({
                id: `Business:${businessId}`,
                fragment: UpdateBusinessFieldInputFragmentDoc,
                data: Object.assign(Object.assign({}, data.business), { [field]: value }),
                broadcast: doBroadcast
            });
        };
    };
    const addressString = [
        (_h = data.business.address) === null || _h === void 0 ? void 0 : _h.neighborhood,
        (_j = data.business.address) === null || _j === void 0 ? void 0 : _j.city,
        (_k = data.business.address) === null || _k === void 0 ? void 0 : _k.stateAbbreviated,
    ]
        .filter((a) => !!a)
        .join(", ");
    return (_jsxs(_Fragment, { children: [_jsxs("div", { className: "text-wfGray-800 w-full", children: [_jsxs(Card, { className: "rounded-none my-8", children: [_jsxs("h2", { className: "text-xl", children: ["Set a cover photo, logo, and description of your business here", fromPreOnboarding ? " (optional)" : "", "."] }), _jsx("div", { className: "mb-2 mt-4 flex flex-auto justify-center w-full justify-items-center", children: _jsx("div", { className: "w-full", children: _jsx("div", { className: "relative w-full", style: {
                                            paddingTop: "29.8%",
                                            backgroundSize: "cover",
                                            backgroundPosition: "center",
                                            backgroundImage: `url(${(_m = (_l = data.business) === null || _l === void 0 ? void 0 : _l.coverPhoto) === null || _m === void 0 ? void 0 : _m.cdnPath})`,
                                        }, children: _jsx("div", { className: "absolute right-07 bottom-07", children: _jsx("div", { className: "relative active:-left-2 active:-bottom-2 bg-white border cursor-pointer border-wfGray-600 hover:border-wfGray-800 px-3.5 py-1.5", children: widget }) }) }) }) }), _jsxs("div", { className: "sm:grid sm:grid-cols-12 pt-2 gap-2 w-full", children: [_jsx("div", { className: "sm:col-span-4 sm:col-start-1", children: _jsx("div", { className: "relative h-0 aspect-ratio-square border border-wfGray-300", style: {
                                                paddingTop: "100%",
                                                backgroundSize: "cover",
                                                backgroundPosition: "center",
                                                backgroundImage: `url(${(_p = (_o = data.business) === null || _o === void 0 ? void 0 : _o.logo) === null || _p === void 0 ? void 0 : _p.cdnPath})`,
                                            }, children: _jsx("div", { className: "absolute right-07 bottom-07", children: _jsx("span", { className: "relative active:-left-2 active:-bottom-2 bg-white border cursor-pointer border-wfGray-600 hover:border-wfGray-800 px-3.5 py-1.5", children: logoWidget }) }) }) }), _jsxs("div", { className: "sm:col-span-8 sm:col-start-5 sm:mb-4 pl-4", children: [_jsx("h2", { className: "font-weight-400 text-wfGray-800 sm:mb-4 mt-8 font-heavy text-4xl", children: data.business.name }), _jsx("div", { className: "text-wfGray-800 mb-8 text-lg", children: addressString }), _jsxs("div", { className: "text-wfGray-800 mb-8 text-lg flex relative", children: [_jsx("label", { htmlFor: "business-mission", children: _jsx(SvgEdit24Px, { className: "text-wfGray-600 fill-current relative top-05 mr-2 cursor-pointer", onClick: () => editDescriptionRef.current.focus() }) }), _jsx(TextInput, { id: "business-mission", innerRef: editDescriptionRef, value: data.business.mission, onChange: updateBusinessField("mission"), placeholder: "Short description of your business" })] })] })] })] }), (theme === null || theme === void 0 ? void 0 : theme.id) && (_jsxs(Card, { className: "rounded-none my-8", children: [_jsx("h2", { className: "text-xl mb-4", children: "Set your brand colors and font here." }), _jsxs("div", { className: "flex items-center mb-4", children: [_jsx("div", { className: "w-52", children: _jsx("label", { children: "Accent Color" }) }), _jsxs("div", { className: "w-1/2", children: [_jsx("div", { className: "w-40 h-10 cursor-pointer border border-gray-300", style: { backgroundColor: theme.highlightColor }, onClick: () => setOpenAccentColorPicker(true) }), openAccentColorPicker && (_jsxs("div", { style: { position: 'absolute', zIndex: '2' }, children: [_jsx("div", { style: { position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' }, onClick: () => setOpenAccentColorPicker(false) }), _jsx(CompactPicker, { color: theme.highlightColor, onChangeComplete: updateThemeField('highlightColor') })] }))] })] }), _jsxs("div", { className: "flex items-center mb-4", children: [_jsx("div", { className: "w-52", children: _jsx("label", { children: "Button Color" }) }), _jsxs("div", { className: "w-1/2", children: [_jsx("div", { className: "w-40 h-10 cursor-pointer border border-gray-300 flex justify-center items-center", style: { backgroundColor: theme.darkColor, color: 'white' }, onClick: () => setOpenButtonColorPicker(true), children: "Sample" }), openButtonColorPicker && (_jsxs("div", { style: { position: 'absolute', zIndex: '2' }, children: [_jsx("div", { style: { position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' }, onClick: () => setOpenButtonColorPicker(false) }), _jsx(CompactPicker, { color: theme.darkColor, onChangeComplete: updateThemeField('darkColor') })] }))] })] }), _jsxs("div", { className: "flex items-center mb-4", children: [_jsx("div", { className: "w-52", children: _jsx("label", { children: "Background Color" }) }), _jsxs("div", { className: "w-1/2", children: [_jsx("div", { className: "w-40 h-10 cursor-pointer border border-gray-300", style: { backgroundColor: theme.defaultColor }, onClick: () => setOpenBackgroundColorPicker(true) }), openBackgroundColorPicker && (_jsxs("div", { style: { position: 'absolute', zIndex: '2' }, children: [_jsx("div", { style: { position: 'fixed', top: '0px', right: '0px', bottom: '0px', left: '0px' }, onClick: () => setOpenBackgroundColorPicker(false) }), _jsx(CompactPicker, { color: theme.defaultColor, onChangeComplete: updateThemeField('defaultColor') })] }))] })] }), _jsxs("div", { className: "flex items-center", children: [_jsx("div", { className: "w-52", children: _jsx("label", { children: "Font" }) }), _jsx("div", { className: "w-1/2", children: _jsxs("select", { value: theme.font, onChange: (e) => updateThemeField('font')(e.target.value), children: [_jsx("option", { value: "", children: "Choose a font..." }), webFonts.map(font => (_jsx("option", { value: font, children: font }, font)))] }) })] })] })), _jsxs(Card, { className: "rounded-none my-8", children: [_jsx("h2", { className: "text-xl", children: "Set short video loop for your upsells here." }), _jsx("div", { children: _jsxs("div", { className: "justify-items-center justify-center text-wfGray-800 text-lg my-8", children: [_jsx(SvgEdit24Px, { onClick: () => editOneLinerRef.current.focus(), className: "text-wfGray-600 inline fill-current cursor-pointer mr-2" }), _jsx(ContentEditable, { html: oneLinerRef.current, id: `business-one-liner`, className: "inline underline focus:ring-transparent focus:outline-none focus:decoration-salmon-600 focus-within:decoration-salmon-600 selection:underline selection:bg-selectionBlue selection:decoration-salmon-600", innerRef: editOneLinerRef, onChange: updateBusinessField("oneLiner"), onBlur: () => {
                                                oneLinerRef.current = stripHtml(editOneLinerRef.current.innerHTML);
                                                // mixpanel.track("Manage Upsells", {
                                                //   action: "Updated One-Liner",
                                                //   value: oneLinerRef.current,
                                                // })
                                            }, onKeyPress: preventEnter }), " ", _jsxs("div", { className: "inline py-2", children: ["by becoming a member of ", data.business.name] })] }) }), _jsx(UpdateVideo, {})] })] }), !fromPreOnboarding && (_jsx("p", { className: "prose mb-4 w-full max-w-full", children: "If you want to make customizations that aren't available here, just reach out to support@withfriends.co or via the chat bubble in the bottom right." }))] }));
};
export default BrandScreenInner;
